import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import $ from 'jquery';

const { skuType1Name, skuType2Name, skuType3Name } = global;
const { amountInput, numberOfGifts, numberOfSkuTypes, optionalSku } = global;

if (typeof window.isGiftOfAnyAmount === 'undefined') {
    var isGiftOfAnyAmount = true;
} else {
    var isGiftOfAnyAmount = window.isGiftOfAnyAmount;
}

// fixed sticky style
const stickyStart = {
    position: 'fixed',
    top: '90px',
    zIndex: '10000',
    boxShadow: '0px 1px 5px 0px rgba(216,216,216,1)'
};

const stickyStop = {
    position: 'absolute',
    bottom: '30px',
    top: 'initial'
}

const category = "Offer " + path;

class MonthlyOffer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {},
            hasError: false,
            stickyTop: null,
            footerOffset: null,
            stickyWidth: null,
            bottom: null,
            isStickyNow: false,
            isSidebarOpen: true,
            currentAmount: 70,
            otherAmount: "",
            amountOptions: amountInput,
            numberOfGifts: numberOfGifts,
            numberOfSkuTypes: numberOfSkuTypes || 2,
            finalSku: "",
            isMobile: false,
            showFormat: true,
            showCalendar: false,
            selectedGift: 2,
            selectedAmountTier: 2,
            selectedFormat: skuType1Name,
            optionalSku: optionalSku,
            calendarChecked: true,
            recurringChecked: false,
            recurringSku: "",
            recurringAmount: "",
            page: 1
        };
        this.makeSticky = this.makeSticky.bind(this);
        this.stopAtFooter = this.stopAtFooter.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleOtherAmountChange = this.handleOtherAmountChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.reallySubmitForm = this.reallySubmitForm.bind(this);
        this.openSidebar = this.openSidebar.bind(this);
        this.closeSidebar = this.closeSidebar.bind(this);
        this.trackGiftSelection = this.trackGiftSelection.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        this.handleRecurring = this.handleRecurring.bind(this);
        this.handleRecurringAmountChange = this.handleRecurringAmountChange.bind(this);

    }

    componentDidMount() {
        Bugsnag.leaveBreadcrumb("React for Monthly Offer loaded.");

        this.init();
        // set default current amount and amount options and number of gifts
        var defaultAmount = amountInput[1];
        if(amountInput.length <= 2){
            defaultAmount = amountInput[0];
        }

        this.setState({
            currentAmount: defaultAmount
        }, this.showGiftOptions()
        );

        var _self = this;
        window.addEventListener('resize', function(){
            // Catch if Android resizing is due to keyboard appearing
            if($(window).width() != _self.state.stickyWidth){
                _self.init();
            }
        });

        // trigger gift selection from images
        $('.forceGiftSelection1').click(function(e){
            if(!$(e.target).hasClass("carousel-control-next-icon") && !$(e.target).hasClass("carousel-control-prev-icon")){
                e.preventDefault();
                if(_self.state.isMobile){
                    _self.openSidebar();
                }
                _self.forceGiftSelection(1);
                $('html,body').animate({scrollTop: $("#stickySidebar").offset().top - 70},300);
            }
        });
        $('.forceGiftSelection2').click(function(e){
            if(!$(e.target).hasClass("carousel-control-next-icon") && !$(e.target).hasClass("carousel-control-prev-icon")){
                e.preventDefault();
                if(_self.state.isMobile){
                    _self.openSidebar();
                }
                _self.forceGiftSelection(2);
                $('html,body').animate({scrollTop: $("#stickySidebar").offset().top - 70},300);
            }
        });
        $('.forceGiftSelection3').click(function(e){
            if(!$(e.target).hasClass("carousel-control-next-icon") && !$(e.target).hasClass("carousel-control-prev-icon")){
                e.preventDefault();
                if(_self.state.isMobile){
                    _self.openSidebar();
                }
                _self.forceGiftSelection(3);
                $('html,body').animate({scrollTop: $("#stickySidebar").offset().top - 70},300);
            }
        });
        $('.forceGiftSelection4').click(function(e){
            if(!$(e.target).hasClass("carousel-control-next-icon") && !$(e.target).hasClass("carousel-control-prev-icon")){
                e.preventDefault();
                if(_self.state.isMobile){
                    _self.openSidebar();
                }
                _self.forceGiftSelection(4);
                $('html,body').animate({scrollTop: $("#stickySidebar").offset().top - 70},300);
            }
        });

        // trigger gift selection from hash
        if(typeof window.location.hash != "undefined"){
            switch(window.location.hash){
                case "#gift1":
                    _self.forceGiftSelection(1);
                    $('html, body').animate({
                        scrollTop: $("#gift1").offset().top - 100
                    }, 300);
                    break;
                case "#gift2":
                    _self.forceGiftSelection(2);
                    $('html, body').animate({
                        scrollTop: $("#gift2").offset().top - 100
                    }, 300);
                    break;
                case "#gift3":
                    _self.forceGiftSelection(3);
                    $('html, body').animate({
                        scrollTop: $("#gift3").offset().top - 100
                    }, 300);
                    break;
                case "#gift4":
                    _self.forceGiftSelection(4);
                    $('html, body').animate({
                        scrollTop: $("#gift4").offset().top - 100
                    }, 300);
                    break;
                default:
                    break;
            }
        }
    }

    init() {
        // check if mobile or desktop first
        if($('.header__hamburger').is(':visible') || window.innerWidth <= 767){
            this.setState({isMobile: true, isSidebarOpen: false}, this.setupMobileMonthlyOffer());
        } else {
            this.setState({isMobile: false, isSidebarOpen: true}, this.setupDesktopMonthlyOffer());
        }
    }

    setupMobileMonthlyOffer() {
        window.removeEventListener('scroll', this.makeSticky);
        window.removeEventListener('scroll', this.stopAtFooter);

        this.setState({stickyWidth: $(window).width(), isSidebarOpen: false})

        // show button on scroll
        $('#stickyMobileButton').addClass('moveIn');
    }

    setupDesktopMonthlyOffer() {
        // bind scroll events only if window size is tall enough
        if($(window).height() > ($('#stickySidebar').height() + 120)){
            window.addEventListener('scroll', this.makeSticky);
            window.addEventListener('scroll', this.stopAtFooter);
        } else {
            $('.get-this-offer').show();
            $('.get-this-offer').css('display','inline-block');
        }

        // get initial offsets and height
        var _self = this;
        $( window ).on( "load", function() {
            _self.setState({
                isSidebarOpen: true
            }, _self.setState({
                stickyInitialTop: $("#stickySidebar").offset().top,
                stickyTop: $("#stickySidebar").offset().top,
                footerOffset: ($("#bottom").offset().top - 30),
                stickyWidth: $("#stickySidebar").outerWidth(),
                innerHeight: $("#stickySidebar").innerHeight(),
            }) );
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        // need check to prevent anyhow triggering
        if (prevState.currentAmount != this.state.currentAmount || prevState.otherAmount != this.state.otherAmount) {
            this.showGiftOptions();
        }
    }

    // on scroll
    // make sidebar sticky
    makeSticky(event) {
        // get body's scrolltop
        // let scrollTop = event.srcElement.body.scrollTop;
        //console.log ($(window).scrollTop());
        //console.log (this.state.stickyInitialTop);
        //console.log ($(window).scrollTop() >= this.state.stickyInitialTop);
        if ($(window).scrollTop() >= this.state.stickyInitialTop){
            this.setState({
                style: stickyStart,
                isStickyNow: true
            });
        }
        else {
            this.setState({
                style: {},
                isStickyNow: false
            });
        }

        // check if height of sticky area exceeds window height, if so make scrollable
        // set state to isBottomHidden
        if(window.innerHeight < $("#stickySidebar").outerHeight()){
            $("#stickySidebarScrollable").css("height",(window.innerHeight-250));
            this.setState({
                bottom: $("#stickySidebar").offset().top + $("#stickySidebar").outerHeight(true)
            });
        }
    }

    // stop stickiness at footer
    stopAtFooter(event) {
        // only when is sticky
        if(this.state.isStickyNow){
            // update top everytime scrolling happens
            this.setState({stickyTop: $("#stickySidebar").offset().top});

            // ensures sticky stops above footer
            // find the bottom of the sticky div first
            this.setState({ bottom: (this.state.stickyTop + this.state.innerHeight) });
            if(this.state.bottom > this.state.footerOffset) {
                this.setState({style: stickyStop});
            }
            // else continue stickiness
            else if($(document).scrollTop() + window.innerHeight < (this.state.footerOffset + 100)){
                this.setState({style: stickyStart});
            }
        }
    }

    showAmount1(){
        this.setState({showFormat: true, selectedAmountTier: 1});
        // enableGift() is now automatic thanks to selectedAmountTier and classNames
        // may as well check option 1
        this.trackGiftSelection(1);
    }

    showAmount2(){
        this.setState({showFormat: true, selectedAmountTier: 2});

        // may as well check option 2
        this.trackGiftSelection(2);
    }

    showAmount3(){
        this.setState({showFormat: true, selectedAmountTier: 3});

        // may as well check option 3
        this.trackGiftSelection(3);
    }

    showAmount4(){
        this.setState({showFormat: true, selectedAmountTier: 4});

        // may as well check option 4
        this.trackGiftSelection(4);
    }

    showNothing(){
        this.setState({showFormat: false, selectedAmountTier: 0});
    }

    // function to show/hide the gift options based on amount
    showGiftOptions(){
        // must clear gift check whenever changed
        $('input[name=sku_code]').prop('checked', false);
        $('input[name=sku_code]').closest('label').removeClass('active').removeClass('focus');

        // determine whether this offer supports $1 to 1st amountOptions[0]
        var shouldShowGift1;
        if(!isGiftOfAnyAmount){
            // decibel behaviour
            shouldShowGift1 = this.state.currentAmount < this.state.amountOptions[1] && this.state.currentAmount >= this.state.amountOptions[0];
        } else {
            // default monthly offer behaviour: allow >= $1
            shouldShowGift1 = this.state.currentAmount < this.state.amountOptions[1] && this.state.currentAmount >= 1;
        }

        if (this.state.amountOptions.length == 2){
            // show Gift #1 only
            if (shouldShowGift1) {
                this.showAmount1();
            }
            // show Gift #1 & #2
            else if (this.state.currentAmount >= this.state.amountOptions[1]) {
                this.showAmount2();
            }
        }
        else if(this.state.amountOptions.length == 3){
            // show Gift #1 only
            if (shouldShowGift1) {
                this.showAmount1();
            }
            // show Gift #1 & #2
            else if (this.state.currentAmount < this.state.amountOptions[2] && this.state.currentAmount >= this.state.amountOptions[1]) {
                this.showAmount2();
            }
            // show all gifts
            else if (this.state.currentAmount >= this.state.amountOptions[2]){
                this.showAmount3();
            } else {
                this.showNothing();
            }
        } else if(this.state.amountOptions.length == 4){
            // show Gift #1 only
            if (shouldShowGift1) {
                this.showAmount1();
            }
            // show Gift #1 & #2
            else if (this.state.currentAmount < this.state.amountOptions[2] && this.state.currentAmount >= this.state.amountOptions[1]) {
                this.showAmount2();
            }
            // show Gift #1, #2, #3
            else if (this.state.currentAmount >= this.state.amountOptions[2] && this.state.currentAmount < this.state.amountOptions[3]){
                this.showAmount3();
            }
            // show Gift #1, #2, #3, #4
            else if (this.state.currentAmount >= this.state.amountOptions[3]){
                this.showAmount4();
            }
            else {
                this.showNothing();
            }
        }
    }

    // when option amount is selected, show gift options
    handleAmountChange(amountValue, e) {
        if(e) e.preventDefault();

        gtag('event', 'Changed Amount (Preset)', {'event_category': category, 'event_label': amountValue.toString()});

        this.setState({currentAmount: amountValue, otherAmount: "", hasError: false });
        $('#otherAmount').removeClass('active');
    }

    handleRecurringAmountChange(e) {
        // var recurringAmt = document.getElementById("recurringAmount").value;
        var recurringAmt = e.target.value;

        this.setState({recurringAmount: recurringAmt});

        // check for errors
        if(this.state.recurringChecked && (e.target.value < 1 || e.target.value === "")){
          this.setState({hasError: true});
        } else {
          this.setState({hasError: false});
        }

        var finalRecurringAmt = parseInt(recurringAmt);
        if(isNaN(finalRecurringAmt)) finalRecurringAmt = 0;

        gtag('event', 'Changed Amount (Other)', {'event_category': category, 'event_label': finalRecurringAmt.toString()});
    }

    // when custom amount box is in focus
    handleOtherAmountChange(e){
        // de-select radios
        // $('.amountOptions.active').removeClass('active');
        // $('input[name=amount]:checked').prop('checked', false);
        // e.preventDefault();
        // e.stopPropagation();

        $('#otherAmount').addClass('active');

        // check for errors
        // errors depend if offer allows $1 to 1st amount
        var isCorrect;
        if(isGiftOfAnyAmount){
            isCorrect = e.target.value >= 1 || e.target.value == "";
        } else {
            // default: allow >=$1
            isCorrect = e.target.value >= this.state.amountOptions[0] || e.target.value == "";
        }
        if(isCorrect){
            this.setState({hasError: false});
        } else {
            this.setState({hasError: true});
        }

        // update gift options based on custom amount
        this.setState({
            currentAmount: e.target.value,
            otherAmount: e.target.value,
        });

        this.showGiftOptions();

        // ensure it is a valid integer before pushing to GA (GA only allows integer)
        var finalValue = parseInt(e.target.value);
        if(isNaN(finalValue)) finalValue = 0;

        // track GA
        gtag('event', 'Changed Amount (Other)', {'event_category': category});
    }

    // submit form
    submitForm(e){
        e.preventDefault();

        // check if amount entered is valid before submitting form
        if((this.state.otherAmount == "" && this.state.currentAmount == "") || (this.state.currentAmount == "" && isNaN(this.state.otherAmount)) || (this.state.currentAmount == "" && this.state.otherAmount < 1)){
            this.setState({hasError: true});
        } else if(this.state.recurringChecked && this.state.recurringAmount < 1) {
            this.setState({hasError: true});
        }
        else {
            this.setState({hasError: false});

            gtag('event', 'Click Submit Form', {'event_category': category});

            this.reallySubmitForm();
        }
    }

    reallySubmitForm() {
        var finalAmount = this.state.currentAmount;
        var finalGiftId = this.state.selectedGift;
        var finalMediaType = this.state.selectedFormat;
        var finalSku, recurringSku, recurringAmount;

        // for OTO
        if(this.state.numberOfSkuTypes == 1){
            // console.log(finalGiftId);
            // Track Donation (no products, donation only)
            if(finalGiftId === 0){
                finalSku = "DONATE";
                finalMediaType = "N/A";
            // for optional SKU
            } else if (finalGiftId === 1){
                if(optionalSku !== "" && this.state.calendarChecked){
                    finalSku = optionalSku;
                } else {
                    finalSku = products[finalGiftId-1].physical;
                }
            } else {
                finalSku = products[finalGiftId-1].physical;
                finalMediaType = "N/A";
            }

            //for MO with 1 sku type
            if(this.state.recurringChecked){
                recurringSku = "GRPMTH";
                recurringAmount = this.state.recurringAmount;
            }
        // for Monthly Offer
        } else {
            if(this.state.recurringChecked){
                recurringSku = "GRPMTH";
                recurringAmount = this.state.recurringAmount;
            }

            if(finalGiftId === 0){
                finalSku = "DONATE";
                finalMediaType = "N/A";
            }
            else if (finalGiftId === 1){
                if(optionalSku !== "" && this.state.calendarChecked){
                    if(finalMediaType === skuType1Name){
                        finalSku = optionalSku;
                    }
                    else if (finalMediaType === skuType2Name) {
                        finalSku = optionalSkuDigital;
                    }
                    else if (finalMediaType === skuType3Name) {
                        finalSku = optionalSkuUsb;
                    }
                } else {
                    if(finalMediaType === skuType1Name){
                        finalSku = products[finalGiftId-1].physical;
                    }
                    else if (finalMediaType === skuType2Name) {
                        finalSku = products[finalGiftId-1].digital;
                    }
                    else if (finalMediaType === skuType3Name) {
                        finalSku = products[finalGiftId-1].usb;
                    }
                }
            }
            else if(finalMediaType === skuType1Name){
                finalSku = products[finalGiftId-1].physical;
            }
            else if (finalMediaType === skuType2Name) {
                finalSku = products[finalGiftId-1].digital;
            }
            else if (finalMediaType === skuType3Name) {
                finalSku = products[finalGiftId-1].usb;
            }
        }

        gtag('event', 'Add to Cart', {'event_category': category, 'event_label': finalAmount.toString()});
        gtag('event', 'Add to Cart - Final Amount', {'event_category': category, 'event_label': finalAmount.toString()});
        gtag('event', 'Add to Cart - Final Gift ID', {'event_category': category, 'event_label': finalGiftId.toString()});
        gtag('event', 'Add to Cart - Final Media Type', {'event_category': category, 'event_label': finalMediaType});
        gtag('event', 'Add to Cart - Final Sku', {'event_category': category, 'event_label': finalSku});

        this.setState({finalSku: finalSku, recurringSku: recurringSku}, function(){
            // submit donation
            if(finalGiftId == 0){
                window.location.href = "/donate/give/checkout/?donation-amount=" + finalAmount;
            } else {
                document.getElementById("monthlyOfferForm").submit();
            }
        });
    }

    trackGiftSelection(giftID,e) {
        if(e) e.preventDefault();

        // make sure we are in page 1
        if(this.state.page !== 1){
            this.goToPage(1);
        }

        // selected gift ID starts from 1
        // 0 is reserved for "no products, donation only"
        this.setState({selectedGift: giftID});

        gtag('event', 'Changed Gift Option', {'event_category': category, 'event_label': giftID.toString()});

        if(giftID == 0){
            this.setState({showFormat: false});
        } else {
            this.setState({showFormat: true});
        }
    }

    trackFormatSelection(formatName,e) {
        if(e) e.preventDefault();

        this.setState({selectedFormat: formatName});

        gtag('event', 'Changed Audio Format', {'event_category': category, 'event_label': formatName});
    }

    forceGiftSelection(giftID){
        gtag('event', 'Changed Gift Option (by clicking on image)', {'event_category': category, 'event_label': giftID.toString()});

        switch(giftID){
            case 1:
                this.trackGiftSelection(1);
                this.handleAmountChange(this.state.amountOptions[0], null);
                this.showGiftOptions();
                window.location.hash = "#gift1";
                break;
            case 2:
                if(this.state.amountOptions.length > 1){
                    this.trackGiftSelection(2);
                    this.handleAmountChange(this.state.amountOptions[1], null);
                    this.showGiftOptions();
                    window.location.hash = "#gift2";
                }
                break;
            case 3:
                if(this.state.amountOptions.length > 2){
                    this.trackGiftSelection(3);
                    this.handleAmountChange(this.state.amountOptions[2], null);
                    this.showGiftOptions();
                    window.location.hash = "#gift3";
                }
                break;
            case 4:
                if(this.state.amountOptions.length > 3){
                    this.trackGiftSelection(4);
                    this.handleAmountChange(this.state.amountOptions[3], null);
                    this.showGiftOptions();
                    window.location.hash = "#gift4";
                }
                break;
            default:
                break;
        }
    }

    isElementInViewport (el) {
        // ref: https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
        if(typeof el === 'undefined'){
            return false;
        } else {
            //special bonus for those using jQuery
            //if (typeof jQuery === "function" && el instanceof jQuery) {
                el = el[0];
            //}

            var rect = el.getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
            )
        }
    }

    openSidebar() {
        var _self = this;

        // // let's try to see which offer is in viewport
        // if(this.isElementInViewport($('.forceGiftSelection1 *'))){
        //     _self.forceGiftSelection(1);
        // }
        // // let's try to see which offer is in viewport
        // else if(this.state.numberOfGifts == 2 && this.isElementInViewport($('.forceGiftSelection2 *'))){

        //     _self.forceGiftSelection(2);
        // }
        // // let's try to see which offer is in viewport
        // else if(this.state.numberOfGifts == 3 && this.isElementInViewport($('.forceGiftSelection3 *'))){
        //     _self.forceGiftSelection(3);
        // }

        this.setState({isSidebarOpen: true},
            function(){
                // check if bottom is hidden
                // _self.checkIfBottomVisible();

                // reset gift options in case
                _self.showGiftOptions();
                $('body').addClass('modal-open');
            }
        );

        // hashtag for routing and GA
        if(history.pushState) {
            history.pushState(null, null, '#get-offer');
        }
        else {
            location.hash = '#get-offer';
        }
        gtag('event', 'page_view', {
            'page_location': location.pathname+location.search+location.hash
        });

        gtag('event', 'Open Get Offer Popup (on Mobile)', {'event_category': category});
    }

    closeSidebar() {
        this.setState({
            isSidebarOpen: false
        });
        $('body').removeClass('modal-open');

        // hashtag for routing and GA
        if(history.pushState) {
            history.pushState(null, null, window.location.pathname);
        }
        else {
            location.hash = '';
        }
        gtag('event', 'page_view', {
            'page_location': location.pathname+location.search+''
        });

        gtag('event', 'Closed Get Offer Popup (on Mobile)', {'event_category': category});
    }

    goToPage(page){
        this.setState({page: page});
        Bugsnag.leaveBreadcrumb("Clicked page " + page);

        gtag('event', 'Go To Page', {'event_category': category, 'event_label': page.toString()});
    }

    handleCalendar(){
        this.setState({calendarChecked: !this.state.calendarChecked});
        var _self = this;

        gtag('event', 'Change Calendar', {'event_category': category, 'event_label': (!_self.state.calendarChecked).toString()});
    }

    handleRecurring(){
        this.setState({recurringChecked: !this.state.recurringChecked});
        var _self = this;

        gtag('event', 'Change Recurring', {'event_category': category, 'event_label': (!_self.state.recurringChecked).toString()});
    }

    render() {
        // saves the width into the state
        var newStyle = Object.assign({}, this.state.style);
        newStyle.width = this.state.stickyWidth + "px";

        var modalClass = classNames({
            "store__monthly-offer__sidebar": true,
            "store__monthly-offer__sidebar--mobile": this.state.isMobile ? true : false,
            "page2": this.state.page === 2 ? true : false
        });

        var _self = this;

        var noProductClasses = classNames({
            'active': (this.state.selectedGift === 0),
            'btn': true,
            'disabled': _self.state.selectedAmountTier === 0
        });
        // console.log("selectedGift",this.state.selectedGift);
        // console.log("selectedAmountTier",this.state.selectedAmountTier);
        // console.log("calendar",this.state.calendarChecked);

        return(
            <div>
                {(this.state.isSidebarOpen) ?
                <div id="stickySidebar" style={newStyle} className={modalClass} role="dialog" aria-labelledby="stickySidebar">
                    <button type="button" className="close hidden-md-up" data-dismiss="modal" aria-label="Close" onClick={this.closeSidebar}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h2 className="store__monthly-offer__sidebar__h2">Get This Offer</h2>
                    <div className="store__monthly-offer__sidebar__scrollable" id="stickySidebarScrollable">
                        <button className="change button--text" onClick={this.goToPage.bind(this,1)}>
                            CHANGE
                        </button>
                        <p className="store__monthly-offer__sidebar__subheader">
                            Gift Amount
                        </p>
                        <div className="btn-group store__monthly-offer__sidebar__amountOptions">
                            {(this.state.amountOptions.map((amount) =>
                                (amount > 0) ?
                                    <button className={(this.state.currentAmount === amount) ? "active btn amountOptions" : "btn amountOptions"}
                                        value={amount} onClick={this.handleAmountChange.bind(this, amount)} key={amount}>
                                         ${amount}
                                    </button>
                                :''
                            ))}
                            <span>
                                <input className={(this.state.hasError) ? "form-control btn-group__other form--danger" : "form-control btn-group__other"}
                                    placeholder="$" id="otherAmount" name="otherAmount" type="number" min="1" step="any"
                                    value={this.state.otherAmount} onClick={this.handleOtherAmountChange} onChange={this.handleOtherAmountChange} />
                            </span>
                            {(!isGiftOfAnyAmount && this.state.hasError) ?
                                <p className="store__monthly-offer__sidebar__subheader ml-2" style={{color: '#e0686b', paddingTop: '5px'}}>
                                <small>Please enter at least ${this.state.amountOptions[0]}</small>
                                </p>
                            :''}
                            <button className="btn finalAmount" onClick={this.goToPage.bind(this,1)}>${this.state.currentAmount}</button>
                        </div>

                        <button className="btn button--text change" onClick={this.goToPage.bind(this,1)}>
                            CHANGE
                        </button>
                        <p className="store__monthly-offer__sidebar__subheader">
                            Choose Your Gift
                        </p>
                        <div className="btn-group store__monthly-offer__sidebar__giftOptions">
                            {(products.map(function(product, index){
                                var btnClass = classNames({
                                    'btn': true,
                                    'active': _self.state.selectedGift == index+1,
                                    'disabled': _self.state.selectedAmountTier < index+1
                                });
                                if(product.title != ""){
                                    return(
                                        <button className={btnClass}
                                            id={"giftOption" + (index+1)}
                                            onClick={(_self.state.page === 1) ? _self.trackGiftSelection.bind(_self,index+1) : _self.goToPage.bind(_self,1)} key={index+1}>
                                            <div className="store__monthly-offer__sidebar__giftOptions__img"
                                                style={{backgroundImage: 'url(//' + CDN_IMAGES_DOMAIN + '/' + product.image + '?w=180&auto=format)', backgroundSize: 'contain'}}></div>
                                            <div className="store__monthly-offer__sidebar__giftOptions__title"
                                                dangerouslySetInnerHTML={{__html: product.title }}>
                                            </div>
                                        </button>
                                    )
                                }
                            }))}
                            <button className={noProductClasses}
                                onClick={this.trackGiftSelection.bind(this,0)}>
                                <div className="store__monthly-offer__sidebar__giftOptions__title" style={{  textAlign: 'center', marginLeft: '0', 'paddingRight': '12px'}}>
                                    No products, donation only
                                </div>
                            </button>
                        </div>

                        {(this.state.page === 2) ?
                            <form method="POST" action="/cart/add" id="monthlyOfferForm" onSubmit={this.submitForm}>
                                {(this.state.numberOfSkuTypes > 1) ?
                                    (this.state.showFormat) ?
                                        <div>
                                            <p className="store__monthly-offer__sidebar__subheader">
                                                Audio Series Format
                                            </p>
                                            <div className="btn-group" id="monthlyOfferLastItem">
                                                <button className={(this.state.selectedFormat === skuType1Name) ? "btn active" : "btn"} onClick={this.trackFormatSelection.bind(this,skuType1Name)} id={'format__' + skuType1Name}>
                                                    {skuType1Name}
                                                </button>
                                                <button className={(this.state.selectedFormat === skuType2Name) ? "btn active" : "btn"} onClick={this.trackFormatSelection.bind(this,skuType2Name)} id={'format__' + skuType2Name}>
                                                    {skuType2Name}
                                                </button>
                                                {(this.state.numberOfSkuTypes == 3) ?
                                                    <button className={(this.state.selectedFormat === skuType3Name) ? "btn active" : "btn"} onClick={this.trackFormatSelection.bind(this,skuType3Name)} id={'format__' + skuType3Name}>
                                                        {skuType3Name}
                                                    </button>
                                                : ''}
                                            </div>
                                        </div>
                                        :''
                                :''
                                }

                                {(this.state.optionalSku !== "" && this.state.selectedGift === parseInt(optionalSkuTier)) ?
                                    <label style={{display: 'block'}} className="store__monthly-offer__sidebar__calendar custom-control custom-checkbox">
                                        <input type="checkbox"
                                            checked={this.state.calendarChecked}
                                            onChange={this.handleCalendar} className="custom-control-input" />
                                            <span className="custom-control-indicator"></span>
                                            <span className="custom-control-description">{optionalSkuName}</span>
                                    </label>
                                :''}

                                <label style={{display: 'block'}} className="store__monthly-offer__sidebar__calendar custom-control custom-checkbox"
                                       data-toggle="collapse" data-target="#collapseDonationDate" aria-expanded="false">
                                    <input type="checkbox"
                                        checked={this.state.recurringChecked}
                                        onChange={this.handleRecurring} className="custom-control-input" />
                                        <span className="custom-control-indicator"></span>
                                        <span className="custom-control-description">Yes, I want to commit to a monthly gift as a Grace Legacy Builder and be part of advancing the gospel of grace</span>
                                </label>
                                <div id="collapseDonationDate" aria-expanded="false" className="collapse">
                                    <span className="custom-control-description"><strong>Gift Amount</strong> &nbsp;</span>
                                    <span>
                                        <input placeholder="$" id="recurringAmount" name="donation_amount" type="number" step="any" className="form-control"
                                               value={this.state.recurringAmount}
                                               onChange={this.handleRecurringAmountChange}/>
                                    </span>
                                </div>

                                <input type="hidden" id="finalSku" name="sku_code" value={this.state.finalSku}></input>
                                <input type="hidden" id="finalAmount" name="amount" value={this.state.currentAmount}></input>
                                <input type="hidden" id="recurringSku" name="recurring_sku_code" value={this.state.recurringSku}></input>
                                <input type="hidden" id="recurringAmount" name="donation_amount" value={this.state.recurringAmount}></input>
                                <input type="hidden" name="_token" defaultValue={csrf_token}></input>
                                {(this.state.hasError) ?
                                    <div className="form-group has-danger">
                                        <div className="form-control-feedback text-center">Please enter a value greater than or equal to $1.00.</div>
                                    </div>
                                : ''}
                                <div className="store__monthly-offer__sidebar__submitWrapper2">
                                {(this.state.hasError) ?
                                    <button className="btn btn-disabled btn-block store__monthly-offer__sidebar__submit" id="monthlyOfferSubmit">Donate</button>
                                    :
                                    <button className="btn btn-primary store__monthly-offer__sidebar__submit" id="monthlyOfferSubmit">Donate</button>
                                }
                                </div>
                            </form>
                        : ''}
                    </div>{/* End of scrollable */}
                    {(this.state.page === 1) ?
                        (this.state.hasError || this.state.currentAmount == "") ?
                            <div className="store__monthly-offer__sidebar__submitWrapper">
                                <button className="btn btn-disabled store__monthly-offer__sidebar__submit" id="monthlyOfferSubmit" disabled="disabled">Next</button>
                            </div>
                            :
                            <div className="store__monthly-offer__sidebar__submitWrapper">
                                <button onClick={this.goToPage.bind(this,2)} className="btn btn-primary store__monthly-offer__sidebar__submit" id="monthlyOfferSubmit">Next</button>
                            </div>
                        :''
                    }
                </div>
                : ''}
                <div className="store__monthly-offer__mobileButton hidden-md-up" id="stickyMobileButton">
                    <button className="btn btn-primary btn-block" onClick={this.openSidebar}>Get this offer</button>
                </div>
            </div>
        )
    }
}

ReactDOM.render(<MonthlyOffer/>, document.getElementById('stickySidebarWrapper'));
